import { useState, useEffect } from 'react';
import { employeeService } from '../../../services/employeeService';
import type { Employee } from '../../../types/Employee';
import type { ServiceArea, ForemanArea } from '../../../services/areasService';

/** Display value for employee dropdown options; matches the format stored in form EmployeeName fields. */
export function employeeOptionName(emp: Employee): string {
  return `${emp.name ?? ''} ${emp.lastName ?? ''}`.trim();
}

/** Active employees for the employee filter dropdown, scoped to the selected service area (report filter value). */
export function useEmployeeOptions(serviceArea: string): Employee[] {
  const [employees, setEmployees] = useState<Employee[]>([]);

  useEffect(() => {
    let cancelled = false;
    const parsed = serviceArea ? parseInt(serviceArea, 10) : NaN;
    const serviceAreaId = !Number.isNaN(parsed) ? parsed : undefined;
    employeeService
      .getActiveEmployeesForSelection(undefined, serviceAreaId)
      .then((list) => {
        if (!cancelled) setEmployees(Array.isArray(list) ? list : []);
      })
      .catch(() => {
        if (!cancelled) setEmployees([]);
      });
    return () => {
      cancelled = true;
    };
  }, [serviceArea]);

  return employees;
}

/** Foreman areas for the foreman area filter dropdown, scoped to the selected service area (report filter value). */
export function getForemanAreaOptions(serviceAreas: ServiceArea[], serviceArea: string): ForemanArea[] {
  const scoped = serviceArea ? serviceAreas.filter((a) => String(a.id) === serviceArea) : serviceAreas;
  return scoped.flatMap((a) => a.foremanAreas ?? []);
}
